import {GET_SETTINGS, POST_SETTINGS, UPDATE_SETTINGS,
     SHOW_NOTIFICATION, CLEAR_NOTIFICATIONS, SET_CURRENT_VIEW,
     LOGOUT, POST_SESSIONS_PRIVACY, POST_SESSIONS_PRIVACY_SUCCESS}
     from './constants';

export const getSettings = name => {
    return {
        type: GET_SETTINGS,
        name
    };
};

export const setCurrentView = name => {
    return {
        type: SET_CURRENT_VIEW,
        name
    };
}

export const saveSettings = (name, userLogout) => {
    return {
        type: POST_SETTINGS,
        name,
        userLogout
    };
};

export const updateSettings = (name, settings) => {
    return {
        type: UPDATE_SETTINGS,
        name,
        settings
    };
};

export const showNotification = (notificationType, msg, fallbackMsg) => {
    return {
        type: SHOW_NOTIFICATION,
        notificationType,
        msg,
        fallbackMsg
    };
};

export const clearNotifications = () => {
    return {
        type: CLEAR_NOTIFICATIONS
    };
};

export const logout = () => {
    return {
        type: LOGOUT
    };
};

export const invalidateAllTrainingShareLinks = () => {
    return {
        type: POST_SESSIONS_PRIVACY
    };
};

export const invalidateAllTrainingShareLinksSuccess = () => {
    return {
        type: POST_SESSIONS_PRIVACY_SUCCESS
    };
};



// WEBPACK FOOTER //
// ./src/UserSettings/actions/index.js